import {useCallback} from 'react';

import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

export interface UseDataFramePageOffsetStateOutput {
  rowsOffset: number;
  onChangeRowsOffset: (rowsOffset: number) => void;
}

const DEFAULT_PAGE_OFFSET = 0;

const dataFramePageOffsetState = makeUseGlobalClientState(DEFAULT_PAGE_OFFSET);

/**
 * Tracks the current row offset for a server-paginated data frame table, keyed by `clientStateId`.
 *
 * Unlike `useDataFrameTablePaginationState`, this does not reset when the underlying data changes, since in
 * server-paginated mode a new page's data legitimately differs from the previous page's on every offset
 * change; auto-resetting on that would make pagination impossible.
 */
export default function useDataFramePageOffsetState(
  clientStateId: string
): UseDataFramePageOffsetStateOutput {
  const [rowsOffset, setRowsOffset] = dataFramePageOffsetState.useGlobalClientState(clientStateId);

  const onChangeRowsOffset = useCallback(
    (newRowsOffset: number) => {
      setRowsOffset(newRowsOffset);
    },
    [setRowsOffset]
  );

  return {rowsOffset, onChangeRowsOffset};
}
